module.exports = __webpack_public_path__ + "media/team/YuYi-89417ecf.png";